import _ from "lodash";
import { AppBar, Box, Button, Divider, Toolbar, useTheme, withStyles } from "@material-ui/core";
import React, { useCallback, useMemo }  from "react";
import { useHistory, useRouteMatch }    from "react-router-dom";
import { useLogin }                     from "../../hooks/useLogin";
import { useLogo }                      from "../../hooks/useLogo";
import { useProfile }                   from "../../hooks/useProfile";
import { RootPages }                    from "../../pages/root/RootPage";

type MatchProps = {
  segment?: string;
};

export const TopBar = () => {
  const { logo }                        = useLogo(),
        match                           = useRouteMatch<MatchProps>("/:segment?"),
        history                         = useHistory(),
        { logout }                      = useLogin(),
        { profile, client }             = useProfile(),
        theme                           = useTheme(),
        DISABLE_APPBAR_THEMING: boolean = process.env.REACT_APP_DISABLE_APPBAR_THEMING !== undefined && process.env.REACT_APP_DISABLE_APPBAR_THEMING.toLowerCase() === "true";

  const StyledAppBar    = withStyles({
    root: {
      '& .MuiButton-root.Mui-disabled': {
        color: theme.palette.secondary.main
      }
    }
  })(AppBar);

  const role            = useMemo(() => profile?.role, [profile]),
        tradingEnabled  = useMemo(() => {
                            try {
                              if (!profile || !profile.featureFlags || !profile.featureFlags.includes('trading') || !client?.tradingEnabled) {
                                return false
                              }
                            } catch {
                              return false
                            }
                            return true
                          }, [profile, client]),
        reportsEnabled  = useMemo(() => {
                            try {
                              if (!profile || !profile.featureFlags || !profile.featureFlags.includes('reports')) {
                                return false
                              }
                            } catch {
                              return false
                            }
                            return true
                          }, [profile])
  const btns            = useMemo(() => {
                            return _.chain(RootPages).toPairs().filter( ([key, p]) => _.includes(p.roles, role) && (("Trading" === p.name) ? tradingEnabled : (("Reports" === p.name) ? reportsEnabled : true))).value()
                          }, [tradingEnabled, reportsEnabled, role])

  const activeTab       = useMemo(() => {
                            return match?.params.segment || "";
                          }, [match]);

  const goto            = useCallback((path: string) => () => {
                            history.push(path)
                          }, [history])

  return (
    <>
      <StyledAppBar position="fixed" color={(DISABLE_APPBAR_THEMING) ? 'default': undefined}>
        <Toolbar>
          <Box pr={3} pl={0}>
            <img height={43.4} src={`data:image/png;base64,${logo || ""}`} alt="logo" />
          </Box>
          <Divider orientation="vertical" flexItem />
          {_.map(btns, ([key, {name, path}]) => (
            <Button key={key} disabled={activeTab === key} color="inherit" onClick={goto(path)} >
              {name || key}
            </Button>
          ))}
          <Box flexGrow={1} />
          <Button color="inherit" onClick={logout}>
            Logout
          </Button>
        </Toolbar>
      </StyledAppBar>
    </>
  );
};
